import { supabase, CheckIn } from './supabase';

// Minimal badge rules for MVP
// - First Light: first check-in
// - Collector I: 10 unique tobaccos
// - Five Star: 10 five-star ratings
// - Pipe Master: 50 pipe check-ins
// - Cigar Aficionado: 50 cigar check-ins

export async function evaluateAndAwardBadges(userId: string) {
  try {
    const { data: allCheckins } = await supabase
      .from('checkins')
      .select('id, rating, tobacco:tobaccos(type), tobacco_id')
      .eq('user_id', userId);

    if (!allCheckins) return;

    const earned: string[] = [];

    // First Light
    if (allCheckins.length >= 1) earned.push('First Light');

    // Collector I (10 unique)
    const uniqueCount = new Set(allCheckins.map((c: any) => c.tobacco_id)).size;
    if (uniqueCount >= 10) earned.push('Collector I');

    // Five Star (10 ratings of 5)
    const fiveStar = allCheckins.filter((c: any) => c.rating === 5).length;
    if (fiveStar >= 10) earned.push('Five Star');

    // Pipe/Cigar counts
    const pipeCount = allCheckins.filter((c: any) => c.tobacco?.type === 'pipe').length;
    const cigarCount = allCheckins.filter((c: any) => c.tobacco?.type === 'cigar').length;
    if (pipeCount >= 50) earned.push('Pipe Master');
    if (cigarCount >= 50) earned.push('Cigar Aficionado');

    if (earned.length === 0) return;

    // Fetch existing user_badges to avoid duplicates
    const { data: existing } = await supabase
      .from('user_badges')
      .select('badge:badges(name), badge_id')
      .eq('user_id', userId);

    const existingNames = new Set((existing || []).map((ub: any) => ub.badge?.name));
    const toAward = earned.filter((n) => !existingNames.has(n));
    if (toAward.length === 0) return;

    // Map names to badge ids
    const { data: badgeRows } = await supabase
      .from('badges')
      .select('id, name')
      .in('name', toAward);

    const inserts = (badgeRows || []).map((b) => ({ user_id: userId, badge_id: b.id }));
    if (inserts.length > 0) {
      await supabase.from('user_badges').insert(inserts);
    }
  } catch (err) {
    console.error('Badges evaluation error', err);
  }
}
